<template>
<v-card>
    <v-card-title class="align-baseline">
        <v-flex xs4>
            <h2>{{ semester }}</h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs4>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-flex>
    </v-card-title>
    <v-data-table :headers="headers" :items="logs" :search="search" :rows-per-page-items="[25,50,100]">
        <template slot="items" slot-scope="props">
            <tr>
                <td>{{ props.item.section }}</td>
                <td>{{ props.item.class }}</td>
                <td>{{ props.item.semester }}</td>
                <td>{{ props.item.first_name }}</td>
                <td>{{ props.item.last_name }}</td>
                <td>{{ props.item.status }}</td>
                <td>{{ props.item.culprit }}</td>
                <td>{{ props.item.date }}</td>
            </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
        </v-alert>
    </v-data-table>
</v-card>
</template>

<script>
export default {
    props: {
        semester: {
            type: String,
            required: true
        },
        logs: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            search: '',
            headers: [{
                    text: 'Section',
                    align: 'left',
                    value: 'section'
                },
                {
                    text: 'Class',
                    align: 'left',
                    value: 'class'
                },
                {
                    text: 'Semester',
                    align: 'left',
                    value: 'semester'
                },
                {
                    text: 'First Name',
                    align: 'left',
                    value: 'first_name'
                },
                {
                    text: 'Last Name',
                    align: 'left',
                    value: 'last_name'
                },
                {
                    text: 'Status',
                    align: 'left',
                    value: 'status'
                },
                {
                    text: 'Culprit',
                    align: 'left',
                    value: 'culprit'
                },
                {
                    text: 'Date',
                    align: 'left',
                    value: 'date'
                },
            ]
        }
    }
}
</script>
